/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'patent/dome_pop': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M27.75 12.336V4.25h-8.086L16 .586 12.336 4.25H4.25v8.086L.586 16l3.664 3.664v8.086h8.086L16 31.414l3.664-3.664h8.086v-8.086L31.414 16l-3.664-3.664zm-.5-7.586v7.086L20.164 4.75h7.086zm-22.5 0h7.086L4.75 11.836V4.75zm0 22.5v-7.086l7.086 7.086H4.75zm22.5 0h-7.086l7.086-7.086v7.086zM16 28.586L3.414 16 16 3.414 28.586 16 16 28.586z"/><path pid="1" d="M17.339 17.833c0-.726-.669-1.453-1.396-1.453s-1.424.728-1.424 1.453.662 1.263 1.401 1.453c-.436 0-.921.726-.921 2.179V24h2v-2.535c0-1.453-.5-2.179-.936-2.179.765-.19 1.276-.725 1.276-1.453z"/><path pid="2" d="M16 7.985l-7.776 7.776 1.027 1.027L16 10.039l6.749 6.749 1.026-1.027z"/>'
  }
})
